module.exports = __webpack_public_path__ + "img/team_brown.7bf199bd.svg";